import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbDropdownModule, NgbPaginationModule, NgbPopoverModule, NgbTimepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LocalDatePipe } from '../../pipes/local-date.pipe';
import { TranslocoRootModule } from '../../transloco/transloco-root.module';
import { StandardContainerComponent } from './standard-container/standard-container.component';
import { StandardDatetimePickerComponent } from './standard-datetime-picker/standard-datetime-picker.component';
import { StandardDropdownResizableMenuComponent } from './standard-dropdown-resizable-menu/standard-dropdown-resizable-menu.component';
import { StandardProgressBarComponent } from './standard-progress-bar/standard-progress-bar.component';
import { StandardRangeDatePickerComponent } from './standard-range-date-picker/standard-range-date-picker.component';
import { StandardTextboxComponent } from './standard-textbox/standard-textbox.component';
import { StandardTimespanComponent } from './standard-timespan/standard-timespan.component';
import { StandardToggleSwitchTriStateComponent } from './standard-toggle-switch-tristate/standard-toggle-switch-tristate.component';
import { StandardToggleSwitchComponent } from './standard-toggle-switch/standard-toggle-switch.component';
import { StandardToolbarComponent } from './standard-toolbar/standard-toolbar.component';
import { StandardToolboxComponent } from './standard-toolbox/standard-toolbox.component';

@NgModule({
    declarations: [
        StandardContainerComponent,
        StandardTextboxComponent,
        StandardToggleSwitchComponent,
        StandardToggleSwitchTriStateComponent,
        StandardToolboxComponent,
        StandardToolbarComponent,
        StandardDatetimePickerComponent,
        StandardRangeDatePickerComponent,
        StandardTimespanComponent,
        StandardDropdownResizableMenuComponent,
        StandardProgressBarComponent,
    ],
    imports: [ReactiveFormsModule, NgbDropdownModule, CommonModule, FormsModule, NgbDatepickerModule, NgbTimepickerModule, NgbPopoverModule, NgbPaginationModule, NgbTooltipModule, LocalDatePipe, TranslocoRootModule],
    exports: [
        StandardContainerComponent,
        StandardTextboxComponent,
        StandardToggleSwitchComponent,
        StandardToggleSwitchTriStateComponent,
        StandardToolboxComponent,
        StandardToolbarComponent,
        NgbTooltipModule,
        StandardDatetimePickerComponent,
        StandardRangeDatePickerComponent,
        StandardTimespanComponent,
        StandardDropdownResizableMenuComponent,
        TranslocoRootModule,
        StandardProgressBarComponent,
    ],
})
export class StandardComponentsModule {}
